import React, { useEffect, useRef, useState } from 'react';
import "./ImageOverview.scss";
import { addImageAsync, deleteImageAsync, fetchImages } from '../../slices/imagesSlice';
import { useDispatch, useSelector } from 'react-redux';
import ESLImages from './Tables/ESLImages';
import { Button } from 'antd';
import { DeleteOutlined, UploadOutlined } from '@ant-design/icons';
import { useNotification } from '../../Helper/NotificationProvider';

const ImageOverview = () => {
  const images = useSelector(state => state.images.data);
  const [data, setData] = useState(images);
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);
  const { openNotification } = useNotification();
  const [selectedRows, setSelectedRows] = useState([])
  const [selectedRowKeys, setSelectedRowKeys] = useState([])

  useEffect(() => {
    dispatch(fetchImages());
  }, []);


  useEffect(() => {
    setData(images)
  }, [images]);

  const onPreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };

  const handleImageUpload = async event => {
    const file = event.target.files[0];

    if (
      file &&
      (file.type === 'image/png' ||
        file.type === 'image/jpeg' ||
        file.type === 'image/svg+xml')
    ) {
      try {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('type', 'location');
        formData.append('tags', 'esl');

        const resultAction = await dispatch(addImageAsync(formData));

        if (addImageAsync.fulfilled.match(resultAction)) {
          openNotification(
            'bottomRight',
            'Erfolg',
            'Bild erfolgreich hochgeladen.',
            true
          );
        } else {
          openNotification(
            'bottomRight',
            'Fehler',
            'Hochladen des Bildes fehlgeschlagen.',
            false
          );
        }
      } catch (error) {
        console.error('Error uploading or retrieving image:', error);
        openNotification(
          'bottomRight',
          'Fehler',
          'Beim Hochladen des Bildes ist ein Fehler aufgetreten.',
          false
        );
      }
    } else {
      openNotification(
        'bottomRight',
        'Fehler',
        'Falsches Bildformat (PNG, JPG, oder SVG).',
        false
      );
    }
  };


  const deleteCheckedRecords = async () => {
    if (selectedRows.length === 0) {
      openNotification(
        'bottomRight',
        "Fehler",
        'Kein Bild zum Löschen ausgewählt.',
        false
      );
      return;
    }

    try {
      const deletePromises = selectedRows.map(row => {
        return dispatch(deleteImageAsync(row.blobId));
      });

      const results = await Promise.all(deletePromises);

      const failedDeletions = results.filter(
        result => deleteImageAsync.rejected.match(result)
      );

      if (failedDeletions.length > 0) {
        openNotification(
          'bottomRight',
          "Fehler",
          'Einige Bilder konnten nicht gelöscht werden. Bitte versuchen Sie es erneut.',
          false
        );
      } else {
        openNotification(
          'bottomRight',
          "Gelöscht",
          'Ausgewählte Bilder wurden gelöscht.',
          true
        );
        dispatch(fetchImages())
      }
      setSelectedRows([]);
    } catch (error) {
      console.error('Error deleting images:', error);
      openNotification(
        'bottomRight',
        "Fehler",
        'Ausgewählte Bilder konnten nicht gelöscht werden. Bitte versuchen Sie es erneut.',
        false
      );
    }
  };

  return (
    <div className="image-container">
      <div className="filters">
        <Button
          type="primary"
          onClick={() => fileInputRef.current.click()}
          icon={<UploadOutlined />}
          style={{
            backgroundColor: 'black',
            marginBottom: 20,
            boxShadow: "0 2px 0 rgba(0, 0, 0, 0.75)"
        }}
        >
          Hochladen
        </Button>
        <Button
          type="primary"
          icon={<DeleteOutlined />}
          disabled={selectedRowKeys.length === 0}
          onClick={deleteCheckedRecords}
          style={{
            backgroundColor: selectedRowKeys.length > 0 && 'black',
            marginBottom: 20,
            boxShadow: selectedRowKeys.length > 0 ? "0 2px 0 rgba(0, 0, 0, 0.75)" : "0 2px 0 rgba(0, 0, 0, 0.1)"
          }}
        >
          Löschen
        </Button>
      </div>
      <div className="table-container">
        <ESLImages
          data={data.filter(entry => entry.tags && entry.tags.includes("esl"))}
          setData={setData}
          onPreview={onPreview}
          setSelectedRowKeys={setSelectedRowKeys}
          setSelectedRows={setSelectedRows}
        />
      </div>
      <input
        type="file"
        accept="image/png, image/jpeg, image/svg+xml"
        ref={fileInputRef}
        onChange={handleImageUpload}
        style={{ display: 'none' }}
      />
    </div>
  );
};

export default ImageOverview;
